import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './AvailableForRepetitionCheckbox.module.scss';

interface IProps {
	toggleAvailableForRepetition: () => void;
	availableForRepetition: boolean;
	isDisabled: boolean;
}

export const AvailableForRepetitionCheckbox: React.FC<IProps> = React.memo(
	({ toggleAvailableForRepetition, availableForRepetition, isDisabled }) => {
		return (
			<Form.Item
				className={style.container}
				name="availableForRepetition"
				data-test="AvailableForRepetitionCheckbox">
				<Checkbox
					onChange={toggleAvailableForRepetition}
					checked={availableForRepetition}
					disabled={isDisabled}>
					<Text translationNameSpace="form" translationKey="availableLabel" asFragment={true} />
				</Checkbox>
			</Form.Item>
		);
	},
);
